import { MenuButton } from "./menu-button.model";

export const NavigationItems: MenuButton[] = [
    // {
    //     label: 'menu.offlinePlan',
    //     link: 'dashboard',
    //     icon: 'search',
    // },
    {
        label: 'menu.offlinePlan',
        link: 'dashboard-new',
        icon: 'dashboard',
    },


];